import {Input as InputPrimitive} from '@base-ui/react/input';

import {cn} from '../../lib/utils';

import type {ComponentProps} from 'react';

function Input({className, type, ...props}: ComponentProps<'input'>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn('input-base field-focus field-error field-disabled', className)}
      {...props}
    />
  );
}

export {Input};
